import { isLikelyInAppWebView, isNativeApp } from './runtimeEnvironment';

type CloseAppWindow = Window & {
  Appilix?: { exitApp?: () => void };
  Android?: { exitApp?: () => void; closeApp?: () => void };
  navigator: Navigator & {
    app?: { exitApp?: () => void };
    device?: { exitApp?: () => void };
  };
};

export function handleCloseApp(): void {
  try {
    const w = window as CloseAppWindow;

    if (w.Appilix && typeof w.Appilix.exitApp === 'function') {
      w.Appilix.exitApp();
      return;
    }
    if (w.Android && typeof w.Android.exitApp === 'function') {
      w.Android.exitApp();
      return;
    }
    if (w.Android && typeof w.Android.closeApp === 'function') {
      w.Android.closeApp();
      return;
    }
    if (w.navigator?.app && typeof w.navigator.app.exitApp === 'function') {
      w.navigator.app.exitApp();
      return;
    }
    if (w.navigator?.device && typeof w.navigator.device.exitApp === 'function') {
      w.navigator.device.exitApp();
      return;
    }

    window.close();
    window.location.href = 'about:blank';
  } catch (error) {
    console.error('Failed to close app:', error);
  }
}

export function shouldShowCloseAppButton(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768 || isNativeApp() || isLikelyInAppWebView();
}
